import React from 'react';

export default function HomeInfo() {
    return <div className="center subtitle">software engineer @ etsy <br/> previously columbia computer science, skillshare, & hackNY</div>
}